module.exports = __webpack_public_path__ + "static/Story-a802b3579fda991631a73a7b570461b3.mp4";